<template>
   <div>

      <h1 class="hidden text-xl uppercase print:block">Asuntohakemus</h1>
      <p class="hidden print:block font-size: 12px;">
         Hakemus jätetty
         {{ new Date().toLocaleDateString("fi-FI") }}
      </p>

      <!-- Hakijan tiedot -->
      <h2 class="mb-2 text-lg font-bold">Hakijan tiedot</h2>
      <table class="w-full mb-5 align-top border border-collapse border-gray-200 table-fixed">
         <tbody class="border border-gray-200">
            <tr class="border-t border-b border-gray-200">
               <td colspan="1" class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Sukunimi</small><br />
                  {{ payload.applicants.primary.lastName }}
               </td>
               <td colspan="2" class="px-1 py-2 border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Etunimet</small><br />
                  {{ payload.applicants.primary.firstNames }}
               </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
               <td colspan="1" class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Henkilötunnus</small><br />
                  {{
                     (payload.applicants.primary.personalNumber && payload.applicants.primary.personalNumber.substr(0,7)
                     ||
                     payload.applicants.primary.passportNumber && payload.applicants.primary.passportNumber.substr(0,7)) + '****'
                  }}
               </td>
               <td colspan="2" class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Kansalaisuus</small><br />
                  {{
                     getSelectedValue(
                        "nationality",
                        payload.applicants.primary.nationalityId
                     )
                  }}
               </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
               <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Kotipaikkakunta</small><br />
                  {{ payload.applicants.primary.placeOfResidence }}
               </td>
               <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Matkapuhelin</small><br />
                  {{ payload.applicants.primary.phoneNumber }}
               </td>
               <td
                  v-if="payload.applicants.primary.emailAddress"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small>Sähköposti</small><br />
                  {{ payload.applicants.primary.emailAddress }}
               </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
               <td colspan="2" class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <small>Katuosoite</small><br />
                  {{ payload.applicants.primary.streetAddress }}
               </td>
               <td colspan="1" class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <small>Postinumero ja -toimipaikka</small><br />
                  {{ payload.applicants.primary.postalCode }}
                  {{ payload.applicants.primary.city }}
               </td>
            </tr>
            <tr class="border-t border-b border-l border-gray-200">
               <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="payload.offerViaSms && payload.offerViaEmail"
               >
                  <small>Lähetä tarjous</small><br />
                  Tekstiviestillä & Sähköpostilla
               </td>
               <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="payload.offerViaSms && !payload.offerViaEmail"
               >
                  <small>Lähetä tarjous</small><br />
                  Tekstiviestillä
               </td>
               <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="!payload.offerViaSms && payload.offerViaEmail"
               >
                  <small>Lähetä tarjous</small><br />
                  Sähköpostilla
               </td>
               <td
                  v-if="payload.proofOfPregnancy.enabled"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small>Raskaustodistus</small><br />
                  Kyllä
               </td>
               <td
                  v-if="payload.proofOfPregnancy.enabled"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small>Laskettu aika</small><br />
                  {{
                     new Date(
                        payload.proofOfPregnancy.dueDate
                     ).toLocaleDateString("fi-Fi")
                  }}
               </td>
            </tr>

            <tr class="border-t border-b border-gray-200" v-if="payload.necessity.primary.mode !== 'homelessness'">
               <td colspan="3" class="w-full px-1 py-2 align-top border border-gray-200">
                  <h3 class="py-1 font-bold">Nykyinen asunto</h3>
               </td>
            </tr>
            <tr class="border-t border-b border-gray-200" v-if="payload.necessity.primary.mode !== 'homelessness'">
               <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <small>Huoneistotyyppi</small><br />
                  {{
                     payload.necessity?.primary.currentApartment?.apartmentType
                  }}
               </td>
               <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <small>Vuokra € / kk</small><br />
                  {{ payload.necessity?.primary.currentApartment?.price }}
               </td>
               <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <small>Neliömäärä m²</small><br />
                  {{
                     payload.necessity?.primary.currentApartment?.apartmentSize
                  }}
               </td>
            </tr>
            <tr class="border-t border-b border-gray-200" v-if="payload.necessity.primary.mode !== 'homelessness'">
               <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <small>Asukkaiden lukumäärä</small><br />
                  {{
                     payload.necessity?.primary.currentApartment
                        ?.numberOfHabitants
                  }}
               </td>
               <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="
                     payload.necessity.primary.currentApartment.ownershipTypeId
                  "
               >
                  <small>Hallintasuhde</small><br />
                  <span
                     v-if="
                        payload.necessity.primary.currentApartment
                           .ownershipTypeId !== 44
                     "
                  >
                     {{
                        getSelectedValue(
                           "currentApartmentOwnershipTypes",
                           payload.necessity?.primary.currentApartment
                              ?.ownershipTypeId
                        )
                     }}
                  </span>
                  <span
                     v-if="
                        payload.necessity.primary.currentApartment
                           .ownershipTypeId === 44
                     "
                  >
                     {{
                        payload.necessity?.primary.currentApartment
                           ?.otherOwnershipType
                     }}
                  </span>
               </td>
            </tr>
            <tr class="border-t border-b border-gray-200" v-if="payload.necessity.primary.mode !== 'homelessness'">
               <td
                  colspan="2"
                  v-if="
                     payload.necessity.primary.currentApartment.landlord.name
                  "
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small>Vuokranantajan nimi</small><br />
                  {{
                     payload.necessity?.primary.currentApartment?.landlord?.name
                  }}
               </td>
               <td
                  v-if="
                     payload.necessity.primary.currentApartment.landlord
                        .phoneNumber
                  "
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small>Vuokranantajan puh</small><br />
                  {{
                     payload.necessity?.primary.currentApartment?.landlord
                        ?.phoneNumber
                  }}
               </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
               <td colspan="3" class="px-1 py-2 align-top border border-gray-200">
                  <h2 class="py-1 font-bold">Tulot ja varallisuus</h2>
               </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
               <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Bruttotulot € / kk</small><br />
                  {{ payload.income.primary.netIncome }}
               </td>
               <td
                  v-if="payload.income.primary.alimony"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small>Elatusmaksu € / kk</small><br />
                  {{ payload.income.primary?.alimony }}
               </td>
               <td
                  v-if="payload.income.primary.wealth.amount"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small
                     >Kiinteistöjen/asuntojen/osakkeiden nykyinen myyntiarvo,
                     tai hakijan osuus tästä (arvio €)</small
                  ><br />
                  {{ payload.income.primary.wealth.amount }}
               </td>
            </tr>
            <tr class="border-t border-b border-gray-200" v-if="payload.income.primary.wealth.amount">
               <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <small>Hakija omistaa kokonaan tai osaksi</small> <br />
                  <ul
                     style="margin: 0; padding: 0 0 0 20px"
                     class="list-disc"
                     v-for="ownedPropertyTypeId in payload.income.primary.wealth
                        .ownedPropertyTypeIds"
                     :key="ownedPropertyTypeId"
                  >
                     <li>
                        {{
                           getSelectedValue(
                              "ownedPropertyTypes",
                              ownedPropertyTypeId
                           )
                        }}
                     </li>
                  </ul>
               </td>
               <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <small>Kiinteistöjen/asuntojen käyttö</small> <br />
                  <ul
                     style="margin: 0; padding: 0 0 0 20px"
                     class="list-disc"
                     v-for="ownedPropertyUseId in payload.income.primary.wealth
                        .ownedPropertyUseIds"
                     :key="ownedPropertyUseId"
                  >
                     <li>
                        {{
                           getSelectedValue(
                              "ownedPropertyUses",
                              ownedPropertyUseId
                           )
                        }}
                     </li>
                  </ul>
               </td>
               <td
                  v-if="payload.income.primary.wealth.otherUse"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small>Muu käyttö</small> <br />
                  {{ payload.income.primary.wealth.otherUse }}
               </td>
            </tr>
            <tr class="border-t border-b border-gray-200" v-if="payload.income.primary.debt.enabled">
               <td
                  v-if="payload.income.primary.debt.amount"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small>Lainan määrä €</small><br />
                  {{ payload.income.primary?.debt?.amount }}
               </td>
               <td
                  v-if="payload.income.primary.debt.amount"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small>Myöntämispäivä</small><br />
                  {{
                     new Date(
                        payload.income.primary?.debt?.startingAt
                     ).toLocaleDateString("fi-FI")
                  }}
               </td>
               <td
                  v-if="payload.income.primary.debt.amount"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small>Takaisinmaksuvuosi</small><br />
                  {{ payload.income.primary?.debt?.repaidYear }}
               </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
               <td
                  v-if="payload.income.primary.debt.studentLoan"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small>Opintolaina €</small><br />
                  {{ payload.income.primary?.debt?.studentLoan }}
               </td>
               <td
                  v-if="payload.income.primary.debt.otherLoan"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small>Muu laina €</small><br />
                  {{ payload.income.primary?.debt?.otherLoan }}
               </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
               <td colspan="3" class="px-1 py-2 align-top border border-gray-200">
                  <h2 class="py-1 font-bold">Asunnon tarpeen syy</h2>
               </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
               <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Asunnontarve alkaen</small>
                  <br />
                  {{
                     new Date(
                        payload.necessity.primary.startingAt
                     ).toLocaleDateString("fi-FI")
                  }}
               </td>
               <td v-if="payload.necessity.primary.moving.startingAt" class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Muutettava pois</small>
                  <br />
                  {{
                     new Date(
                        payload.necessity.primary.moving.startingAt
                     ).toLocaleDateString("fi-FI")
                  }}
               </td>
               <td
                  v-if="payload.necessity.primary.relocation.reason"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small>Muuttosyy</small><br />
                  <span
                     v-if="payload.necessity.primary.relocation.reason !== 79"
                  >
                     {{
                        getSelectedValue(
                           "reasonsForRelocation",
                           payload.necessity.primary.relocation.reason
                        )
                     }}
                  </span>
                  <span
                     v-if="payload.necessity.primary.relocation.reason === 79"
                  >
                     {{ payload.necessity.primary.otherDetails }}
                  </span>
               </td>
               <td
                  v-if="payload.necessity.primary.homelessness.reason"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small>Asunnottomuuden syy</small><br />
                  {{
                     getSelectedValue(
                        "reasonsForHomelessness",
                        payload.necessity.primary.homelessness.reason
                     )
                  }}
               </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
               <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="payload.necessity.primary.relocation.reason === 78"
               >
                  <small>Oppilaitos</small><br />
                  {{ payload.necessity.primary.relocation.school.name }}
               </td>
               <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="payload.necessity.primary.relocation.reason === 77"
               >
                  <small>Työnantaja</small><br />
                  {{ payload.necessity.primary.relocation.employer.name }}
               </td>
               <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="payload.necessity.primary.relocation.reason === 77"
               >
                  <small>Työpaikan osoite</small><br />
                  {{ payload.necessity.primary.relocation.employer.address }}
               </td>
               <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="payload.necessity.primary.relocation.reason === 77"
               >
                  <small>Työn alkamispäivä</small><br />
                  {{
                     new Date(
                        payload.necessity.primary.relocation.employer.startingAt
                     ).toLocaleDateString("fi-FI")
                  }}
               </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
               <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="payload.necessity.primary.moving.necessity"
               >
                  <small>Muuttovelvoite</small><br />
                  {{
                     getSelectedValue(
                        "necessitiesForMove",
                        payload.necessity.primary.moving.necessity
                     )
                  }}
               </td>
               <td
                   colspan="2"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="
                     payload.necessity.primary.moving
                        .reasonCurrentApartmentIsUnsuitable
                  "
               >
                  <small>Nykyinen asunto sopimaton, koska:</small><br />
                  <span
                     v-if="
                        payload.necessity.primary.moving
                           .reasonCurrentApartmentIsUnsuitable !== 190
                     "
                  >
                     {{
                        getSelectedValue(
                           "reasonsCurrentApartmentIsUnsuitable",
                           payload.necessity.primary.moving
                              .reasonCurrentApartmentIsUnsuitable
                        )
                     }}
                  </span>
                  <span
                     v-if="
                        payload.necessity.primary.moving
                           .reasonCurrentApartmentIsUnsuitable === 190
                     "
                  >
                     {{
                        payload.necessity.primary.moving
                           .otherReasonCurrentApartmentIsUnsuitable
                     }}
                  </span>
               </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
               <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="
                     payload.necessity.primary.otherDetails &&
                     payload.necessity.primary.relocation.reason !== 79
                  "
               >
                  <small>Muut syyt</small><br />
                  {{ payload.necessity.primary.otherDetails }}
               </td>
            </tr>
         </tbody>
      </table>

      <!-- Kanssahakijan tiedot -->
      <h2  v-if="payload.applicants.secondary.enabled" class="pt-3 mb-2 text-lg font-bold">Kanssahakijan tiedot</h2>
      <table  v-if="payload.applicants.secondary.enabled" class="w-full mb-5 align-top border border-collapse border-gray-200 table-fixed">
        <tbody class="border border-gray-200">
            <tr class="border-t border-b border-gray-200">
              <td colspan="1" class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Sukunimi</small><br />
                  {{ payload.applicants.secondary.lastName }}
              </td>
              <td colspan="2" class="px-1 py-2 border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Etunimet</small><br />
                  {{ payload.applicants.secondary.firstNames }}
              </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
              <td colspan="1" class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Henkilötunnus</small><br />
                  {{
                    (payload.applicants.secondary.personalNumber && payload.applicants.secondary.personalNumber.substr(0,7) ||
                    payload.applicants.secondary.passportNumber && payload.applicants.secondary.passportNumber.substr(0,7)) + "****"
                  }}
              </td>
              <td colspan="2" class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Kansalaisuus</small><br />
                  {{
                    getSelectedValue(
                        "nationality",
                        payload.applicants.secondary.nationalityId
                    )
                  }}
              </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
              <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Kotipaikkakunta</small><br />
                  {{ payload.applicants.secondary.placeOfResidence }}
              </td>
              <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Matkapuhelin</small><br />
                  {{ payload.applicants.secondary.phoneNumber }}
              </td>
              <td
                  v-if="payload.applicants.secondary.emailAddress"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
              >
                  <small>Sähköposti</small><br />
                  {{ payload.applicants.secondary.emailAddress }}
              </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
              <td colspan="2" class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <small>Katuosoite</small><br />
                  {{ payload.applicants.secondary.livingWithPrimary
                    ? payload.applicants.primary.streetAddress
                    : payload.applicants.secondary.streetAddress
                  }}
              </td>
              <td colspan="1" class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <small>Postinumero ja -toimipaikka</small><br />
                  {{ payload.applicants.secondary.livingWithPrimary
                    ? payload.applicants.primary.postalCode
                    : payload.applicants.secondary.postalCode
                  }}
                  {{ payload.applicants.secondary.livingWithPrimary
                    ? payload.applicants.primary.city
                    : payload.applicants.secondary.city
                  }}
              </td>
            </tr>
            <tr class="border-t border-b border-l border-gray-200">
              <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="payload.offerViaSms && payload.offerViaEmail"
              >
                  <small>Lähetä tarjous</small><br />
                  Tekstiviestillä & Sähköpostilla
              </td>
              <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="payload.offerViaSms && !payload.offerViaEmail"
              >
                  <small>Lähetä tarjous</small><br />
                  Tekstiviestillä
              </td>
              <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="!payload.offerViaSms && payload.offerViaEmail"
              >
                  <small>Lähetä tarjous</small><br />
                  Sähköpostilla
              </td>
              <td
                  v-if="payload.proofOfPregnancy.enabled"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
              >
                  <small>Raskaustodistus</small><br />
                  Kyllä
              </td>
              <td
                  v-if="payload.proofOfPregnancy.enabled"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
              >
                  <small>Laskettu aika</small><br />
                  {{
                    new Date(
                        payload.proofOfPregnancy.dueDate
                    ).toLocaleDateString("fi-Fi")
                  }}
              </td>
            </tr>

            <tr class="border-t border-b border-gray-200" v-if="payload.necessity.secondary.mode !== 'homelessness'">
              <td colspan="3" class="w-full px-1 py-2 align-top border border-gray-200">
                  <h2 class="py-1 font-bold">Nykyinen asunto</h2>
              </td>
            </tr>
            <tr class="border-t border-b border-gray-200" v-if="payload.necessity.secondary.mode !== 'homelessness'">
              <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <small>Huoneistotyyppi</small><br />
                  {{
                    payload.necessity?.secondary.currentApartment?.apartmentType
                  }}
              </td>
              <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <small>Vuokra € / kk</small><br />
                  {{ payload.necessity?.secondary.currentApartment?.price }}
              </td>
              <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <small>Neliömäärä m²</small><br />
                  {{
                    payload.necessity?.secondary.currentApartment?.apartmentSize
                  }}
              </td>
            </tr>
            <tr class="border-t border-b border-gray-200" v-if="payload.necessity.secondary.mode !== 'homelessness'">
              <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <small>Asukkaiden lukumäärä</small><br />
                  {{
                    payload.necessity?.secondary.currentApartment
                        ?.numberOfHabitants
                  }}
              </td>
              <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="
                    payload.necessity.secondary.currentApartment.ownershipTypeId
                  "
              >
                  <small>Hallintasuhde</small><br />
                  <span
                    v-if="
                        payload.necessity.secondary.currentApartment
                          .ownershipTypeId !== 44
                    "
                  >
                    {{
                        getSelectedValue(
                          "currentApartmentOwnershipTypes",
                          payload.necessity?.secondary.currentApartment
                              ?.ownershipTypeId
                        )
                    }}
                  </span>
                  <span
                    v-if="
                        payload.necessity.secondary.currentApartment
                          .ownershipTypeId === 44
                    "
                  >
                    {{
                        payload.necessity?.secondary.currentApartment
                          ?.otherOwnershipType
                    }}
                  </span>
              </td>
            </tr>
            <tr class="border-t border-b border-gray-200" v-if="payload.necessity.secondary.mode !== 'homelessness'">
              <td
                  colspan="2"
                  v-if="
                    payload.necessity.secondary.currentApartment.landlord.name
                  "
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
              >
                  <small>Vuokranantajan nimi</small><br />
                  {{
                    payload.necessity?.secondary.currentApartment?.landlord?.name
                  }}
              </td>
              <td
                  v-if="
                    payload.necessity.secondary.currentApartment.landlord
                        .phoneNumber
                  "
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
              >
                  <small>Vuokranantajan puh</small><br />
                  {{
                    payload.necessity?.secondary.currentApartment?.landlord
                        ?.phoneNumber
                  }}
              </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
              <td colspan="3" class="px-1 py-2 align-top border border-gray-200">
                  <h2 class="py-1 font-bold">Tulot ja varallisuus</h2>
              </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
              <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Bruttotulot € / kk</small><br />
                  {{ payload.income.secondary.netIncome }}
              </td>
              <td
                  v-if="payload.income.secondary.alimony"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
              >
                  <small>Elatusmaksu € / kk</small><br />
                  {{ payload.income.secondary?.alimony }}
              </td>
              <td
                  v-if="payload.income.secondary.wealth.amount"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
              >
                  <small
                    >Kiinteistöjen/asuntojen/osakkeiden nykyinen myyntiarvo,
                    tai hakijan osuus tästä (arvio €)</small
                  ><br />
                  {{ payload.income.secondary.wealth.amount }}
              </td>
            </tr>
            <tr class="border-t border-b border-gray-200" v-if="payload.income.secondary.wealth.amount">
              <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <small>Hakija omistaa kokonaan tai osaksi</small> <br />
                  <ul
                    style="margin: 0; padding: 0 0 0 20px"
                    class="list-disc"
                    v-for="ownedPropertyTypeId in payload.income.secondary.wealth
                        .ownedPropertyTypeIds"
                    :key="ownedPropertyTypeId"
                  >
                    <li>
                        {{
                          getSelectedValue(
                              "ownedPropertyTypes",
                              ownedPropertyTypeId
                          )
                        }}
                    </li>
                  </ul>
              </td>
              <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <small>Kiinteistöjen/asuntojen käyttö</small> <br />
                  <ul
                    style="margin: 0; padding: 0 0 0 20px"
                    class="list-disc"
                    v-for="ownedPropertyUseId in payload.income.secondary.wealth
                        .ownedPropertyUseIds"
                    :key="ownedPropertyUseId"
                  >
                    <li>
                        {{
                          getSelectedValue(
                              "ownedPropertyUses",
                              ownedPropertyUseId
                          )
                        }}
                    </li>
                  </ul>
              </td>
              <td
                  v-if="payload.income.secondary.wealth.otherUse"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
              >
                  <small>Muu käyttö</small> <br />
                  {{ payload.income.secondary.wealth.otherUse }}
              </td>
            </tr>
            <tr class="border-t border-b border-gray-200" v-if="payload.income.secondary.debt.enabled">
              <td
                  v-if="payload.income.secondary.debt.amount"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
              >
                  <small>Lainan määrä €</small><br />
                  {{ payload.income.secondary?.debt?.amount }}
              </td>
              <td
                  v-if="payload.income.secondary.debt.amount"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
              >
                  <small>Myöntämispäivä</small><br />
                  {{
                    new Date(
                        payload.income.secondary?.debt?.startingAt
                    ).toLocaleDateString("fi-FI")
                  }}
              </td>
              <td
                  v-if="payload.income.secondary.debt.amount"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
              >
                  <small>Takaisinmaksuvuosi</small><br />
                  {{ payload.income.secondary?.debt?.repaidYear }}
              </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
              <td
                  v-if="payload.income.secondary.debt.studentLoan"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
              >
                  <small>Opintolaina €</small><br />
                  {{ payload.income.secondary?.debt?.studentLoan }}
              </td>
              <td
                  v-if="payload.income.secondary.debt.otherLoan"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
              >
                  <small>Muu laina €</small><br />
                  {{ payload.income.secondary?.debt?.otherLoan }}
              </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
              <td colspan="3" class="px-1 py-2 align-top border border-gray-200">
                  <h2 class="py-1 font-bold">Asunnon tarpeen syy</h2>
              </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
              <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Asunnontarve alkaen</small>
                  <br />
                  {{
                    new Date(
                        payload.necessity.secondary.startingAt
                    ).toLocaleDateString("fi-FI")
                  }}
              </td>
              <td v-if="payload.necessity.secondary.moving.startingAt" class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Muutettava pois</small>
                  <br />
                  {{
                    new Date(
                        payload.necessity.secondary.moving.startingAt
                    ).toLocaleDateString("fi-FI")
                  }}
              </td>
              <td
                  v-if="payload.necessity.secondary.relocation.reason"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
              >
                  <small>Muuttosyy</small><br />
                  <span
                    v-if="payload.necessity.secondary.relocation.reason !== 79"
                  >
                    {{
                        getSelectedValue(
                          "reasonsForRelocation",
                          payload.necessity.secondary.relocation.reason
                        )
                    }}
                  </span>
                  <span
                    v-if="payload.necessity.secondary.relocation.reason === 79"
                  >
                    {{ payload.necessity.secondary.otherDetails }}
                  </span>
              </td>
              <td
                  v-if="payload.necessity.secondary.homelessness.reason"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
              >
                  <small>Asunnottomuuden syy</small><br />
                  {{
                    getSelectedValue(
                        "reasonsForHomelessness",
                        payload.necessity.secondary.homelessness.reason
                    )
                  }}
              </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
              <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="payload.necessity.secondary.relocation.reason === 78"
              >
                  <small>Oppilaitos</small><br />
                  {{ payload.necessity.secondary.relocation.school.name }}
              </td>
              <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="payload.necessity.secondary.relocation.reason === 77"
              >
                  <small>Työnantaja</small><br />
                  {{ payload.necessity.secondary.relocation.employer.name }}
              </td>
              <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="payload.necessity.secondary.relocation.reason === 77"
              >
                  <small>Työpaikan osoite</small><br />
                  {{ payload.necessity.secondary.relocation.employer.address }}
              </td>
              <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="payload.necessity.secondary.relocation.reason === 77"
              >
                  <small>Työn alkamispäivä</small><br />
                  {{
                    new Date(
                        payload.necessity.secondary.relocation.employer.startingAt
                    ).toLocaleDateString("fi-FI")
                  }}
              </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
              <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="payload.necessity.secondary.moving.necessity"
              >
                  <small>Muuttovelvoite</small><br />
                  {{
                    getSelectedValue(
                        "necessitiesForMove",
                        payload.necessity.secondary.moving.necessity
                    )
                  }}
              </td>
              <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="
                    payload.necessity.secondary.moving
                        .reasonCurrentApartmentIsUnsuitable
                  "
              >
                  <small>Nykyinen asunto sopimaton, koska:</small><br />
                  <span
                    v-if="
                        payload.necessity.secondary.moving
                          .reasonCurrentApartmentIsUnsuitable !== 190
                    "
                  >
                    {{
                        getSelectedValue(
                          "reasonsCurrentApartmentIsUnsuitable",
                          payload.necessity.secondary.moving
                              .reasonCurrentApartmentIsUnsuitable
                        )
                    }}
                  </span>
                  <span
                    v-if="
                        payload.necessity.secondary.moving
                          .reasonCurrentApartmentIsUnsuitable === 190
                    "
                  >
                    {{
                        payload.necessity.secondary.moving
                          .otherReasonCurrentApartmentIsUnsuitable
                    }}
                  </span>
              </td>
            </tr>
            <tr class="border-t border-b border-gray-200">
              <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="
                    payload.necessity.secondary.otherDetails &&
                    payload.necessity.secondary.relocation.reason !== 79
                  "
              >
                  <small>Muut syyt</small><br />
                  {{ payload.necessity.secondary.otherDetails }}
              </td>
            </tr>
        </tbody>
      </table>

      <!-- Muut asumaan tulevat henkilöt -->
      <h2 v-if="payload.applicants.other.length > 0" class="w-full pt-5 mb-2 text-lg font-bold">Muut asumaan tulevat henkilöt</h2>
      <table v-if="payload.applicants.other.length > 0" class="w-full mb-5 align-top border border-collapse border-gray-200 table-fixed">
         <tbody class="border border-gray-200">
            <tr class="border-t border-b border-gray-200" v-for="other in payload.applicants.other" :key="other">
               <td class="px-1 py-2 align-top border border-gray-200">
                  <small>Sukunimi</small><br />{{ other.lastName }}
               </td>
               <td class="px-1 py-2 align-top border border-gray-200">
                  <small>Etunimet</small><br />{{ other.firstNames }}
               </td>
               <td class="px-1 py-2 align-top border border-gray-200">
                  <small>Henkilötunnus</small><br />{{
                     (other.personalNumber && other.personalNumber.substr(0,7)
                     ||
                     other.passportNumber && other.passportNumber.substr(0,7)) + "****"
                  }}
               </td>
            </tr>
         </tbody>
      </table>

      <!-- Haettava huoneisto -->
      <h2 class="w-full pt-3 mb-2 text-lg font-bold">Haettava huoneisto</h2>
      <table class="w-full mb-5 align-top border border-collapse border-gray-200 table-fixed">
         <tbody class="border border-gray-200">
            <tr class="border-t border-b border-gray-200">
               <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <!-- pakollinen tieto -->
                  <small>Haettava kunta</small><br />
                  {{ getSelectedValue("locations", payload.locationId) }}
               </td>
               <td
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
                  v-if="payload.districtIds.length > 0"
               >
                  <small>Kaupunginosat</small><br />
                  <ul
                     style="margin: 0; padding: 0 0 0 20px"
                     class="list-disc"
                     v-for="district in payload.districtIds"
                     :key="district"
                  >
                     <li>
                        {{ getSelectedValue("districts", district) }}
                     </li>
                  </ul>
               </td>
            </tr>

            <tr class="border-t border-b border-gray-200">
               <td
                  v-if="payload.apartmentTypeIds.length > 0"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small>Huoneistotyypit</small><br />
                  <ul
                     style="margin: 0; padding: 0 0 0 20px"
                     class="list-disc"
                     v-for="apartmentTypeId in payload.apartmentTypeIds"
                     :key="apartmentTypeId"
                  >
                     <li>
                        {{
                           getSelectedValue("apartmentTypes", apartmentTypeId)
                        }}
                     </li>
                  </ul>
               </td>
               <td
                  v-if="payload.buildingTypeIds.length > 0"
                  class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <small>Talotyypit</small>
                  <ul
                     style="margin: 0; padding: 0 0 0 20px"
                     class="list-disc"
                     v-for="buildingTypeId in payload.buildingTypeIds"
                     :key="buildingTypeId"
                  >
                     <li>
                        {{ getSelectedValue("buildingTypes", buildingTypeId) }}
                     </li>
                  </ul>
               </td>
            </tr>

            <tr class="border-t border-b border-gray-200" v-if="payload.featureIds.length > 0">
               <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">Erikoisvalinnat</td>
               <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  <div
                    v-for="featureId in payload.featureIds" :key="featureId">
                     <p>
                        {{ getSelectedValue("features", featureId) }}
                     </p>
                  </div>
               </td>
            </tr>

            <tr class="border-t border-b border-gray-200" v-if="payload.priceMax">
               <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">Enimmäisvuokra</td>
               <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">
                  {{ payload.priceMax }} &euro; / kk
               </td>
            </tr>

            <tr class="border-t border-b border-gray-200" v-if="payload.favorites.length > 0">
              <td class="px-1 py-2 align-top border-t border-b border-l border-gray-200">Huoneistot</td>
              <td
                class="px-1 py-2 align-top border-t border-b border-l border-gray-200"
               >
                  <div
                     v-for="favorite in payload.favorites"
                     :key="favorite.id"
                  >
                     <p>
                        {{ favorite.buildingType }} -
                        {{ favorite.streetAddress }} -
                        {{ favorite.postOffice }}
                     </p>
                  </div>
               </td>
            </tr>

         </tbody>
      </table>
   </div>
</template>

<script>
export default {
   name: "Summary",
   props: {
      payload: {
         type: Object,
      },
      options: {
         type: Object,
      },
   },
   setup(props) {
      function getSelectedValue(category, id) {
         // props/categories:
         // apartmentTypes, applicationTypes, buildingTypes,currentApartmentBuildingTypes, currentApartmentOwnershipTypes, districts, employmentTypes, features, locations, nationality, necessitiesForMove, ownedPropertyTypes, ownedPropertyUses, reasonsCurrentApartmentIsUnsuitable, reasonsForHomelessness, reasonsForRelocation
         let values = props.options[category];
         let selected = values.filter((value) => value.id === id);
         return selected[0].name;
      }
      return {
         getSelectedValue,
      };
   },
};
</script>
